import Main from './Page'

export default [
  {
    path: '/planos', component: Main, name: 'planos.main'
  }
]
